// Blueprint export/apply mutations.
//
// These back the Admin "Blueprint Manager" deploy flow. Deployment logic (reconciling standards by
// fingerprint, remapping instances, applying column configs) lives in the backend applyBlueprint
// mutation; the UI just gathers inputs and renders the structured result. `scope` lets each tab
// deploy only its slice (STANDARDS / INSTANCES / COLUMNS) or everything at once (ALL).

// Exports the given DataSources as a portable blueprint JSON string.
export const exportBlueprint = /* GraphQL */ `
  mutation ExportBlueprint($dataSourceIds: [Int!]!) {
    exportBlueprint(dataSourceIds: $dataSourceIds)
  }
`;

// Applies a blueprint onto existing DataSources in the current environment (matched by name).
export const applyBlueprint = /* GraphQL */ `
  mutation ApplyBlueprint(
    $blueprint: String!
    $sourcePairings: [SourcePairingInputModelInput!]
    $permissions: [BusinessRuleStandardPermissionsInputModelInput!]
    $applyColumnConfigurations: Boolean!
    $dryRun: Boolean!
    $renameOnConflict: Boolean!
    $scope: BlueprintApplyScope!
  ) {
    applyBlueprint(
      blueprint: $blueprint
      sourcePairings: $sourcePairings
      permissions: $permissions
      applyColumnConfigurations: $applyColumnConfigurations
      dryRun: $dryRun
      renameOnConflict: $renameOnConflict
      scope: $scope
    ) {
      dryRun
      warnings
      standards {
        name
        status
        message
      }
      instances {
        targetSourceName
        ruleInstanceName
        status
        message
        policyId
        unmatchedColumns
        errors
      }
      columns {
        targetSourceName
        columnName
        status
        message
      }
    }
  }
`;

// The scope values accepted by the applyBlueprint `scope` argument (GraphQL enum BlueprintApplyScope).
export const BlueprintApplyScope = Object.freeze({
  All: "ALL",
  Standards: "STANDARDS",
  Instances: "INSTANCES",
  Columns: "COLUMNS",
});
